import {Component, OnInit} from '@angular/core';
import {FaqService} from '../../../../services/faq.service';
import {FaqArticle} from '../../../../model/faq-article';
import {FaqCategoryService} from '../../../../services/faq-category.service';
import {FaqCategory} from '../../../../model/FaqCategory';
import {RouterLink} from "@angular/router";
import {SortPipe} from "../../../common/SortPipe";
import {UrlDecodePipe} from "../../../common/UrlDecodePipe";
import {BadgeComponent} from "../../../common/badge/badge.component";
import {DashBlockComponent} from "../dash-block.component";

import {HttpClient} from "@angular/common/http";
import {Release} from "../../../../model/release";
import {forkJoin} from "rxjs";
import {map} from "rxjs/operators";

@Component({
    selector: 'app-dash-block-rn',
    templateUrl: './dash-block-rn.component.html',
    imports: [
    RouterLink,
    UrlDecodePipe,
    BadgeComponent,
    DashBlockComponent
],
    styleUrls: ['./dash-block-rn.component.css']
})
export class DashBlockRnComponent implements OnInit {
  error = false;
  hasRn = false;

  allVersions: Release[] = [];
  categories: FaqCategory[];
  latestVersions: Release[];

  constructor(private http: HttpClient,
              private faqCategoryService: FaqCategoryService) {
  }

  ngOnInit(): void {
    this.faqCategoryService.getObjects().subscribe(cats => {
      this.categories = cats;
    });
    const $obs = [];
    this.http.get<FaqCategory[]>("/api/v1/rn").subscribe(r => {
      this.hasRn = r.length > 0;

      r.forEach((cat: FaqCategory) => {
        $obs.push(this.http.get<Release[]>("/api/v1/rn/" + cat.slug).pipe(map(
          (c) => {
            c.forEach((release: Release) => release.category = cat);
            this.allVersions = this.allVersions.concat(c);
          }
        )));
      });
      forkJoin($obs).subscribe(() => {
        this.latestVersions = this.allVersions.sort((a: Release, b: Release) => new Date(a.released_at).getTime() - new Date(b.released_at).getTime()).reverse().splice(0, 3);
      });
    });
  }

  getMinorVersion(version: string) {
    const minorFound = /(\d+\.\d+).*/.exec(version);
    if(minorFound.length > 1) {
      return minorFound[1]
    } else {
      return undefined;
    }
  }
}
